export var EcommerceSegmentationType;
(function (EcommerceSegmentationType) {
    EcommerceSegmentationType["CustomerType"] = "customer_type";
    EcommerceSegmentationType["OrderStatus"] = "order_status";
    EcommerceSegmentationType["PaymentMethod"] = "payment_method";
    EcommerceSegmentationType["Purchase"] = "purchase";
    EcommerceSegmentationType["PurchaseFrequency"] = "purchase_frequency";
    EcommerceSegmentationType["Shipping"] = "shipping";
    EcommerceSegmentationType["Location"] = "location";
    EcommerceSegmentationType["Category"] = "category";
    EcommerceSegmentationType["Store"] = "store";
})(EcommerceSegmentationType || (EcommerceSegmentationType = {}));
